import React, { useContext, useEffect, useState } from "react";
import AdminScreen from "Screens/AdminScreen";
import Container from "Screens/Container";
import { AppContext } from "context/App";
import { Formik, Form } from "formik";
import { LicenseValidationSchema } from "schemas/License";
import PrimaryButton from "components/Buttons/PrimaryButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { oauthPut } from "helpers/Request";
import { useAuth } from "hooks/Auth";
import { useNotification } from "hooks/Notification";
import TextArea from "components/FormElements/TextArea";
import TextInput from "components/FormElements/TextInput";
import Text from "components/FormElements/Text";
import SelectBox from "components/FormElements/SelectBox";
import timezones from "assets/timezones.json";

export default function PublicationScreen(props) {
    const auth = useAuth();
    const notification = useNotification();

    const { setCurrentNav } = useContext(AppContext);
    const [saving, setSaving] = useState(false);

    const onSubmit = (values) => {
        setSaving(true);
        oauthPut("/api/v2/license/" + auth.publication.uuid, values)
            .then((data) => {
                setSaving(false);
                notification.show("Publication saved");
                return data;
            })
            .then((data) => {
                setTimeout(() => {
                    window.location.reload();
                }, 1);
            })
            .catch((e) => {
                notification.show(
                    "There was an error saving. Please try again."
                );
                setSaving(false);
            });
    };

    useEffect(() => {
        setCurrentNav("publication");
    }, [setCurrentNav]);

    return (
        <AdminScreen>
            <Container>
                <div className="z-50 max-w-3xl mx-auto rounded-t-md text-center relative">
                    <div className="overflow-hidden h-28">
                        <img
                            src={process.env.PUBLIC_URL.concat("/1500x500.png")}
                            alt="Header Background"
                            className="z-0 w-max overflow-hidden rounded-t-md"
                        />
                    </div>
                </div>
                <div className="max-w-3xl mx-auto bg-white rounded-b-md p-4 shadow-sm pt-6">
                    <Formik
                        enableReinitialize={true}
                        validationSchema={LicenseValidationSchema}
                        initialValues={{
                            name: auth.publication.name,
                            description: auth.publication.description,
                            timezone: auth.publication.timezone,
                            uri: auth.publication.uri,
                            billing_name: auth.publication.billing_name,
                            billing_contact: auth.publication.billing_contact,
                        }}
                        onSubmit={onSubmit}
                    >
                        {(props) => (
                            <Form className="space-y-8">
                                <TextInput
                                    label="Publication Name"
                                    id="name"
                                    name="name"
                                    type="text"
                                />

                                <div className="flex space-x-4">
                                    <div className="grow">
                                        <TextInput
                                            label="Billing Contact Name"
                                            id="billing_name"
                                            name="billing_name"
                                            helpertext="Contact name for billing questions."
                                            type="text"
                                        />
                                    </div>
                                    <div className="grow">
                                        <TextInput
                                            label="Email or Phone"
                                            id="billing_contact"
                                            name="billing_contact"
                                            helpertext="Email or phone number for billing questions."
                                            type="text"
                                        />
                                    </div>
                                </div>

                                <TextArea
                                    label="Description"
                                    id="description"
                                    name="description"
                                />

                                <TextInput
                                    label="Default URI"
                                    id="uri"
                                    name="uri"
                                    type="text"
                                    helpertext="Your site's main web address."
                                />

                                <SelectBox
                                    label="Timezone"
                                    id="timezone"
                                    name="timezone"
                                    options={timezones}
                                    helpertext="The primary timezone of your site."
                                />

                                <Text
                                    label="Client Code"
                                    value={auth.publication.client_code}
                                />

                                <Text
                                    label="License ID"
                                    value={
                                        "srn::publication:" +
                                        auth.publication.uuid
                                    }
                                />
                                <div className="flex justify-end">
                                    <SecondaryButton type="button">
                                        Cancel
                                    </SecondaryButton>
                                    <PrimaryButton
                                        type="submit"
                                        className="ml-3"
                                        blocking={saving}
                                    >
                                        Save
                                    </PrimaryButton>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </Container>
        </AdminScreen>
    );
}
